import Map from '@arcgis/core/Map';
export const createMap = () => {
  return new Map({});
};
